var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vue-input-tag-wrapper",
      class: { "read-only": _vm.readOnly },
      on: {
        click: function ($event) {
          return _vm.focusNewTag()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "field is-grouped is-grouped-multiline" },
        [
          _vm._l(_vm.innerTags, function (tag, index) {
            return _c(
              "div",
              { key: index, staticClass: "control adjust-margin" },
              [
                _c("div", { staticClass: "tags has-addons" }, [
                  _c(
                    "span",
                    { staticClass: "tag", class: _vm.tagColour },
                    [
                      _vm._t(
                        "tag",
                        function () {
                          return [_vm._v(" " + _vm._s(tag) + " ")]
                        },
                        { tag: tag, index: index }
                      ),
                    ],
                    2
                  ),
                  !_vm.readOnly
                    ? _c("a", {
                        staticClass: "tag is-delete",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.remove(index)
                          },
                        },
                      })
                    : _vm._e(),
                ]),
              ]
            )
          }),
          _c("div", { staticClass: "control" }, [
            !_vm.readOnly && !_vm.isLimit
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newTag,
                      expression: "newTag",
                    },
                  ],
                  ref: "inputtag",
                  staticClass: "new-tag",
                  attrs: {
                    placeholder: _vm.placeholder,
                    type: "text",
                    disabled: !_vm.allowInput,
                  },
                  domProps: { value: _vm.newTag },
                  on: {
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "delete",
                            [8, 46],
                            $event.key,
                            ["Backspace", "Delete", "Del"]
                          )
                        )
                          return null
                        $event.stopPropagation()
                        return _vm.removeLastTag.apply(null, arguments)
                      },
                      _vm.addNew,
                    ],
                    blur: _vm.addNew,
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.newTag = $event.target.value
                    },
                  },
                })
              : _vm._e(),
          ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }